// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer--footer--3N4oY","divider":"Footer--divider--1_N8Q","links":"Footer--links--1I7l7"};